import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IOfferListOffer} from "../../offer/types/IOfferListOffer";
import {getAmplitudeOfferListItem} from "./get_amplitude_offer_list_item";

export interface ITrackAmplitudeOfferViewItemListParams {
    offers: IOfferListOffer[];
    itemListName: string | string[];
}

export const trackAmplitudeOfferViewItemList = (params: ITrackAmplitudeOfferViewItemListParams) => {
    const {offers, itemListName} = params;

    trackAmplitudeEvent("view_item_list", {
        item_list_name: itemListName,
        PRODUCTS: offers.map((offer, index) => getAmplitudeOfferListItem({offer, index: index + 1}))
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IOfferListOffer} from "../../offer/types/IOfferListOffer";
import {getAmplitudeOfferListItem} from "./get_amplitude_offer_list_item";

export interface ITrackAmplitudeOfferViewItemListParams {
    offers: IOfferListOffer[];
    itemListName: string | string[];
}

export const trackAmplitudeOfferViewItemList = (params: ITrackAmplitudeOfferViewItemListParams) => {
    const {offers, itemListName} = params;

    trackAmplitudeEvent("view_item_list", {
        item_list_name: itemListName,
        PRODUCTS: offers.map((offer, index) => getAmplitudeOfferListItem({offer, index: index + 1}))
    });
};
